import React, { useState, useEffect } from 'react';
import './styles.css';
import FloatingActions, { FloatingAction } from '../FloatingActions';
import Card from '../Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons';
import { RouterStoreItemKey } from '@/store/useRouter/types';
import useRouter from '@/store/useRouter';
import { useShallow } from 'zustand/shallow';
import axios from "axios";
import useAppData from '@/store/useAppData';
import { StockMovement } from '@/Utils/constants';
import { toLocalDateTimeOffset } from '../DeicingForm';

export type StockItem = {
    id: string;
    name?: string;
    quantity?: number;
    quantityToAdd?: number;
    autofill?: boolean;
}

const StockingDeicingCard: React.FC = () => {

    const selectedStock = useAppData(state => state.selectedStock);
    const loggedUser = useAppData(state => state.user);
    const [stockingItemsState, setStockingItemsState] = useState<StockItem[]>([]);
    const [editingValue, setEditingValue] = useState<Record<number, string>>({});

    const router = useRouter(
        useShallow(state => ({
            go: state.go,
            history: state.history
        }))
    );

    const actions: FloatingAction[] = [
        {
            key: "3",
            label: "Zrušit",
            icon: <FontAwesomeIcon icon={faXmark} />,
            onClick: () => router.go({ key: RouterStoreItemKey.LISTITEMS })
        },
        {
            key: "1",
            label: "Uložit",
            icon: <FontAwesomeIcon icon={faFloppyDisk} />,
            onClick: () => onSave()
        }
    ];

    useEffect(() => {

        const init = async () => {
            const stockItems = await getStockItems();
            setStockingItemsState(stockItems?.filter(stockItem => !stockItem?.autofill));
        };

        init();
    }, []);

    const onSave = async () => {
        await updateItems();
        router.go({ key: RouterStoreItemKey.LISTITEMS });
    }

    const getStockItems = async () => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/stockitem/getAll",
                    data: {
                        start: 0,
                        end: 100,
                        stockId: selectedStock?.id
                    }
                })
            );

            return res.data.stocksItems;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    const updateItem = async (item: StockItem) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/stockitem/updateIncrement2",
                data: {
                    id: item.id,
                    quantity: item.quantityToAdd
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to updateIncrement stock item", err);
            throw err;
        }
    };

    const stockMovement = async (stockId: string, stockItemId: string, stockMovementId: string, quantity: number, userId: string) => {
        try {
            const res = await axios({
                method: "post",
                url: "/api/log/stockMoveOdmraz",
                data: {
                    stockId: stockId,
                    stockItemId: stockItemId,
                    quantity: quantity,
                    stockMovementId: stockMovementId,
                    userId: userId,
                    date: toLocalDateTimeOffset(new Date())
                },
            });

            return res.data.id;
        } catch (err) {
            console.error("Failed to make stock movement item", err);
            throw err;
        }
    };

    const updateItems = async () => {
        await Promise.all(
            stockingItemsState
                .filter(({ quantityToAdd }) => (quantityToAdd ?? 0) != 0)
                .map(async stockItem => {
                    await updateItem(stockItem);
                    await stockMovement(selectedStock.id, stockItem.id, String(StockMovement.StockIn), stockItem.quantityToAdd!, loggedUser!.id);
                })
        );
    };

    const updateStockItem = (
        id: StockItem["id"],
        values: Partial<StockItem>
    ) => {
        setStockingItemsState(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, ...values }
                    : item
            )
        );
    };

    return <>
        <Card
            title="Příjem na sklad"
        >
            <div className="item-list-stack">

                {stockingItemsState?.map(stockItem =>
                (
                    <div className="stock-item-row">
                        <label className="stock-item-field col-name">
                            <span className="stock-item-label">Název</span>
                            <input
                                className="stock-item-control"
                                type="text"
                                disabled={true}
                                value={stockItem?.name}
                            />
                        </label>

                        <label className="stock-item-field col-amount">
                            <span className="stock-item-label">Počet na skladě</span>
                            <input
                                className="stock-item-control"
                                type="number"
                                disabled={true}
                                value={stockItem.quantity}
                            />
                        </label>

                        <label className="stock-item-field col-amount">
                            <span className="stock-item-label">Počet</span>
                            {/* <input
                                className="stock-item-control stock-item-control-edit"
                                type="number"
                                value={stockItem.quantityToAdd}
                                onChange={(e) =>
                                    updateStockItem(stockItem.id, {
                                        quantityToAdd: Number(e.target.value)
                                    })
                                }
                            /> */}
                            {/* <input
                                className="stock-item-control stock-item-control-edit"
                                type="text"
                                inputMode="numeric"
                                onFocus={(e) => e.target.select()}
                                value={(stockItem.quantityToAdd ?? 0).toLocaleString("cs-CZ")}
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\s/g, "");

                                    const allowNegative = stockItem.name === "IBC kontejner";

                                    const regex = allowNegative
                                        ? /^-?\d*$/
                                        : /^\d*$/;

                                    if (!regex.test(value)) {
                                        return;
                                    }

                                    updateStockItem(stockItem.id, {
                                        quantityToAdd:
                                             value === "" || value === "-"
                                                ? 0
                                                : Number(value)
                                    });
                                }}
                            /> */}
                            <input
                                className="stock-item-control stock-item-control-edit"
                                type="text"
                                inputMode="numeric"
                                onFocus={(e) => {
                                    e.target.select();

                                    setEditingValue(prev => ({
                                        ...prev,
                                        [stockItem.id]: String(stockItem.quantityToAdd ?? 0)
                                    }));
                                }}
                                value={
                                    editingValue[stockItem.id] ??
                                    (stockItem.quantityToAdd ?? 0).toLocaleString("cs-CZ")
                                }
                                onChange={(e) => {
                                    const value = e.target.value.replace(/\s/g, "");

                                    const allowNegative = stockItem.name === "IBC kontejner";

                                    const regex = allowNegative
                                        ? /^-?\d*$/
                                        : /^\d*$/;

                                    if (!regex.test(value)) {
                                        return;
                                    }

                                    // Zachová i samotné "-"
                                    setEditingValue(prev => ({
                                        ...prev,
                                        [stockItem.id]: value
                                    }));

                                    // Do modelu ukládáme pouze validní číslo
                                    if (value !== "" && value !== "-") {
                                        updateStockItem(stockItem.id, {
                                            quantityToAdd: Number(value)
                                        });
                                    }
                                }}
                                onBlur={() => {
                                    setEditingValue(prev => {
                                        const next = { ...prev };
                                        delete next[stockItem.id];
                                        return next;
                                    });
                                }}
                            />
                            <div className="controls">
                                <button
                                    type="button"
                                    disabled={(stockItem?.quantityToAdd || 0) >= 1000000}
                                    onClick={() =>
                                        updateStockItem(stockItem.id, {
                                            quantityToAdd: (stockItem?.quantityToAdd || 0) + 1
                                        })
                                    }
                                >
                                    ▲
                                </button>
                                <button
                                    type="button"
                                    disabled={stockItem.name === "IBC kontejner" ? false : (stockItem?.quantityToAdd || 0) <= 0}
                                    onClick={() =>
                                        updateStockItem(stockItem.id, {
                                            quantityToAdd: (stockItem?.quantityToAdd || 0) - 1
                                        })
                                    }
                                >
                                    ▼
                                </button>
                            </div>
                        </label>
                    </div>
                )
                )}
            </div>

            {actions?.length ? (
                <div className="item-list-actions">
                    <FloatingActions actions={actions} />
                </div>
            ) : null}
        </Card></>;
};

export default StockingDeicingCard;